import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TopPlayerDto } from '@poker-stats/contracts';

const initialState: {
  loading: boolean;
  loadingData: boolean;
  topPlayers: Array<TopPlayerDto>;
} = {
  loading: false,
  loadingData: false,
  topPlayers: [],
};

export const topPlayersReducer = createSlice({
  name: 'topPlayers',
  initialState,
  reducers: {
    loadTopPlayers(
      state,

      _action: PayloadAction<{
        tableSizeFilterValue?: number; //id фильтра
        limitFilterValue?: number; //id фильтра
        dateFilterValue?: number; //id фильтра
        pokersiteFilterValue?: number;
        customDateFilterValue?: { fromDate: string; toDate: string };
      }>,
    ) {
      state.loadingData = true;
    },
    setLoadedTopPlayers(state, action: PayloadAction<Array<TopPlayerDto>>) {
      state.loading = false;
      state.loadingData = false;
      state.topPlayers = action.payload;
    },
  },
});
